import { Injectable } from '@angular/core';
import { AppSettings } from '../_helpers/app.settings';
import { ApiConfig } from '../_helpers/api-config';
import { Request } from '../_helpers/request';
import { HttpService } from '../shared/http.service';
import { TokenStorageService } from '../_helpers/token-storage.service';

@Injectable({
  providedIn: 'root'
})
export class ForgotPasswordService {

  constructor(
    private http: HttpService,
    private tokenStorage: TokenStorageService
  ) { }
  
  forgot(param: any){
    let req: Request = {
      method: AppSettings.HTTP_METHODS.GET,
      url: `${ApiConfig.forgotPassword}?user=${param.data.user}`,
      success: param.success ? param.success : null,
      error: param.error ? param.error : null
    }
    this.http.sendRequest(req);
  };
}
